import React from 'react'
import { Box, Tooltip } from '@mui/material'

/**
 * StatusBadge - A reusable status indicator component
 * @param {string} label - The text to display in the badge
 * @param {string} color - Material UI color name ('error', 'warning', 'success', 'info')
 * @param {string} size - Size variant ('small', 'medium', 'large')
 * @param {string|ReactNode} tooltip - Optional tooltip content
 * @param {object} sx - Additional Material UI sx props
 */
const StatusBadge = ({ 
  label, 
  color = 'info', 
  size = 'small',
  tooltip,
  sx = {},
  ...props 
}) => {
  const sizeStyles = {
    small: {
      fontSize: '0.65rem',
      px: 1,
      py: 0.5,
      borderRadius: 1
    },
    medium: {
      fontSize: '0.75rem',
      px: 1.5,
      py: 0.75,
      borderRadius: 1.5
    },
    large: {
      fontSize: '0.85rem',
      px: 2,
      py: 1,
      borderRadius: 2
    }
  }

  const badgeElement = (
    <Box
      sx={{
        display: 'inline-block',
        fontWeight: 600,
        textAlign: 'center',
        backgroundColor: 
          color === 'error' ? 'error.main' :
          color === 'warning' ? 'warning.main' :
          color === 'success' ? 'success.main' : 
          'info.main',
        color: 
          color === 'error' ? 'error.contrastText' :
          color === 'warning' ? 'warning.contrastText' :
          color === 'success' ? 'success.contrastText' : 
          'info.contrastText',
        ...sizeStyles[size],
        ...sx,
        cursor: tooltip ? 'help' : 'default'
      }}
      {...props}
    >
      {label}
    </Box>
  )

  if (tooltip) {
    return (
      <Tooltip title={tooltip} arrow placement="top">
        {badgeElement}
      </Tooltip>
    )
  }

  return badgeElement
}

export default StatusBadge